import styled, { css } from 'styled-components';

import { newTableTokens } from '../../../../tokens/components/NewTable/tokens';

import CoreRow from '../../_common/CoreRow';

/* @internal */
export const StyledOrderableRow = styled(CoreRow)`
  position: relative;
  z-index: 1;
  box-shadow: 0 0 1px 1px ${newTableTokens.CellBorderColorBaseDefault};

  &:focus-visible {
    outline: 0;
  }

  ${({ theme }) =>
    theme.isDragging &&
    css`
      display: table !important;
      box-shadow: 0 1px 2px 1px ${newTableTokens.CellBorderColorBaseDefault};
      border-top: 1px solid ${newTableTokens.CellBorderColorBaseKeyboardFocus};
      border-color: ${newTableTokens.CellBorderColorBaseKeyboardFocus};
    `}

  // Adds a top border to first row if there isn't a header defined
  ${({ theme }) =>
    !theme.isDragging &&
    css`
      #orderable-key-pair:first-child &:first-of-type {
        border-top: 1px solid ${newTableTokens.CellBorderColorBaseDefault};
      }
    `}
`;
